import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {
  firstName: any = ""
  userRoles: any = []
  organizationId:any = ""
  orgName:any  = ""
  constructor(public router: Router) { }

  ngOnInit(): void {

  }

  isLoggedIn() {
    let ret = false;
    if (sessionStorage.getItem('isLoggedIn') == "true") {
      this.firstName = sessionStorage.getItem('firstName');
      this.organizationId = sessionStorage.getItem('organizationId');
      this.orgName= sessionStorage.getItem('orgName');
      let urs: any = sessionStorage.getItem('userRoles');
      this.userRoles = JSON.parse(urs);
      ret = true;
    }
    return ret;
  }
  logout() {
    sessionStorage.setItem('isLoggedIn', "false");
    sessionStorage.setItem('token', "GetOrganizations");
    this.router.navigate(['login']);

  }
  hasRole(sRole: string) {
    let ret = false
    this.userRoles.forEach((x: string) => { if (x == sRole) ret = true })
    return ret
  }
}
